export default "__VITE_PUBLIC_ASSET__41df1cd1__"